if (!customElements.get('deployer-quantity-breaks')) {
    customElements.define(
      'deployer-quantity-breaks',
      class DeployerQuantityBreaks extends HTMLElement {
        constructor() {
          super();
          this.main_product_form = this.closest('.jolly-main-product').querySelector('.product-form') || document.querySelector('.product__page form[action*="/cart/add"]') || document.querySelector('.product form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add.js"]') || document.querySelector('form[action*="/cart/add"]');
          this.main_product_section_id = this.dataset.sectionId;
          this.variant_mode = this.getAttribute('data-variant-mode');
          if (this.main_product_form === null) return console.error('Deployer Quantity Breaks: No product form found');
  
          // update when variant changes (works with Broadcast, Prestige, Dawn & co, Impulse)
          if (this.main_product_form.querySelector('input[name="id"]') !== null) {
            this.main_product_form.querySelector('input[name="id"]').addEventListener('change', (event) => {
              this.renderDeployerQuantityBreaks(event.target.value);
            });
          } else {
            if (typeof subscribe === 'function') {
              this.variantChangeSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                this.renderDeployerQuantityBreaks(event.data.variant.id);
              });
            } else {
              document.addEventListener('variant:change', (event) => {
                this.renderDeployerQuantityBreaks(event.detail.variant.id);
              });
            }
          }
        }
  
        connectedCallback() {
          this.updatePrices();
          this.updateSubWidgetPrices();

          this.updateFormInputs(this.getSelectedQuantity());

          // update when quantity changes
          if (this.variant_mode == 'no-variant') {
            this.querySelectorAll('.quantity-break').forEach((quantity_break) => {
              quantity_break.addEventListener('click', () => {
                this.selectQuantity(quantity_break);
                this.updateFormInputs(quantity_break);
                this.updateSubWidgetPrices();
              });
            });
          } else if (this.variant_mode == 'select') {
            // update when variant changes in quantity break
            this.querySelectorAll('.quantity-break').forEach((quantity_break) => {
              quantity_break.addEventListener('click', () => {
                this.selectQuantity(quantity_break);
                setTimeout(() => {
                  this.updateFormInputs(quantity_break);
                  const variantsSelectedAvailable = Array.from(quantity_break.querySelectorAll('deployer-quantity-break-variant-picker')).every((fieldset) => fieldset.dataset.available === 'true');
                  if (variantsSelectedAvailable) {
                    this.toggleAddButton(false, '', false);
                  } else {
                    this.toggleAddButton(true, '', false);
                  }
                });
              });
            });
          } else if (this.variant_mode == 'distribution') {
            const blockDistribution = this.querySelector('deployer-quantity-break-distribution');
  
            // update when variant changes in quantity break
            this.querySelectorAll('.quantity-break').forEach((quantity_break) => {
              quantity_break.addEventListener('click', () => {
                this.selectQuantity(quantity_break);
                blockDistribution.refresh();
              });
            });
          }
        }

        updatePrices(discountPercents = null){
          const subscriptionWidget = document.querySelector('subscription-widget');
          if(!subscriptionWidget) return;

          if (!discountPercents) discountPercents = document.querySelector('subscription-widget.active').dataset.discountPercents;

          const pricesToUpdate = this.querySelectorAll('.quantity-break_price-container_price, .quantity-break_price-container_compare-at-price');

          pricesToUpdate.forEach((price) => {
            const priceCents = parseInt(price.dataset.priceCents);
            const quantity = parseInt(price.dataset.quantity);
            const priceToUpdate = this.formatPrice(priceCents, quantity, discountPercents);

            price.innerText = priceToUpdate;
          });

          this.updateCTAPrice(this.getSelectedQuantity());

        }

        updateSubWidgetPrices(){
          const selectedQuantityBreak = this.getSelectedQuantity();
          this.updateCTAPrice(selectedQuantityBreak);


          const selectedQuantityBreakPriceCents = selectedQuantityBreak.querySelector('.quantity-break_price-container_price').dataset.priceCents;

          const priceOneTimeElement = document.querySelector('.jc-onetime-input .js-update-price');
          priceOneTimeElement.innerText = this.formatPrice(parseInt(selectedQuantityBreakPriceCents), parseInt(selectedQuantityBreak.dataset.quantity), parseInt(priceOneTimeElement.closest('subscription-widget').dataset.discountPercents));

          const priceSubscriptionElement = document.querySelector('.jc-subscription-input .js-update-price');

          priceSubscriptionElement.innerText = this.formatPrice(parseInt(selectedQuantityBreakPriceCents), parseInt(selectedQuantityBreak.dataset.quantity), parseInt(priceSubscriptionElement.closest('subscription-widget').dataset.discountPercents));

          
          const selectedQuantityBreakCompareAtPrice = selectedQuantityBreak.querySelector('.quantity-break_price-container_compare-at-price');

          const priceSubscriptionCompareAtPriceElement = document.querySelector('.jc-subscription-input .sub-compare-price');
          const priceOneTimeCompareAtPriceElement = document.querySelector('.js-onetime-compare-at-price');

          if(selectedQuantityBreakCompareAtPrice){
            priceSubscriptionCompareAtPriceElement.classList.remove('hidden');
            priceSubscriptionCompareAtPriceElement.innerText = this.formatPrice(parseInt(selectedQuantityBreakCompareAtPrice.dataset.priceCents), parseInt(selectedQuantityBreak.dataset.quantity), parseInt(priceSubscriptionCompareAtPriceElement.closest('subscription-widget').dataset.discountPercents));
          } else{
            priceSubscriptionCompareAtPriceElement.classList.add('hidden');
            priceSubscriptionCompareAtPriceElement.innerText = "";
          }

          if(selectedQuantityBreakCompareAtPrice){
            priceOneTimeCompareAtPriceElement.classList.remove('hidden');

            priceOneTimeCompareAtPriceElement.innerText = this.formatPrice(parseInt(selectedQuantityBreakCompareAtPrice.dataset.priceCents), parseInt(selectedQuantityBreak.dataset.quantity), 0);
          } else{
            priceOneTimeCompareAtPriceElement.classList.add('hidden');
            priceOneTimeCompareAtPriceElement.innerText = "";
          }
        }

        formatPrice(cents, quantity, discountPercents = 0){
          const unitPrice = (cents / quantity);

          const unitPriceReduced = (unitPrice * (1 - (discountPercents / 100))).toFixed(2);
          
          const finalPrice = unitPriceReduced * quantity / 100;

          const finalPriceHtml = document.body.dataset.currency + finalPrice.toFixed(2).replace('.', ',')

          return finalPriceHtml;
        }
  
        renderDeployerQuantityBreaks(variant_id) {
          this.classList.add('loading');
          var variant_param = '?variant=' + variant_id + '&';
          if (variant_id === undefined) variant_param = '?';
  
          fetch(window.location.pathname + variant_param + 'section_id=' + this.main_product_section_id)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
  
              const deployerQuantityBreaksSource = html.querySelector('deployer-quantity-breaks');
              const deployerQuantityBreaksDestination = this;
  
              if (deployerQuantityBreaksSource && deployerQuantityBreaksDestination) {
                deployerQuantityBreaksDestination.innerHTML = deployerQuantityBreaksSource.innerHTML;
                deployerQuantityBreaksDestination.connectedCallback();
              }
            })
            .then(() => {
              this.classList.remove('loading');
            });
        }
  
        selectQuantity(quantity_break) {
          if (quantity_break.classList.contains('disabled-quantity-break')) return;
          this.resetSelectedQuantity();
          quantity_break.classList.add('selected-quantity-break');
        }
  
        resetSelectedQuantity() {
          this.querySelectorAll('.quantity-break').forEach((quantity_break) => {
            quantity_break.classList.remove('selected-quantity-break');
          });
        }
  
        updateFormInputs(quantity_break) {
          this.clearFormInputs();
          if (this.variant_mode == 'no-variant') {
            if (this.main_product_form.querySelector('jolly-quantity-selector input[name="quantity"]')) {
              this.main_product_form.querySelector('jolly-quantity-selector input[name="quantity"]').value = parseInt(quantity_break.getAttribute('data-quantity'));
            } else {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'quantity';
              input.value = quantity_break.getAttribute('data-quantity');
              this.main_product_form.appendChild(input);
            }
          } else if (this.variant_mode == 'select') {
            const variantsPickers = quantity_break.querySelectorAll('deployer-quantity-break-variant-picker');
            if (variantsPickers.length > 0) {
              variantsPickers.forEach((variantsPicker, index) => {
                if (index === 0) {
                  this.main_product_form.querySelector('input[name="id"]').value = variantsPicker.dataset.id;
                } else {
                  const inputName = `items[${index}][id]`;
                  const inputValue = variantsPicker.dataset.id;
                  const inputElement = document.createElement('input');
                  inputElement.type = 'hidden';
                  inputElement.name = inputName;
                  inputElement.value = inputValue;
                  this.main_product_form.appendChild(inputElement);
                }
              });
            }
          }

          this.updateCTAPrice(quantity_break);
          
        }

        updateCTAPrice(quantity_break){
            const ctaPrice = quantity_break.querySelector('.quantity-break_price-container_price').innerText;

            document.querySelectorAll('.jc-current-price').forEach(price => {
                price.innerText = ctaPrice;
            });
        }
  
        clearFormInputs() {
          // remove all the inputs in the form that the name starts with "items"
          const inputs = this.main_product_form.querySelectorAll('input[name^="items"]');
          inputs.forEach((input) => {
            this.main_product_form.removeChild(input);
          });
        }
  
        getSelectedQuantity() {
          return this.querySelector('.selected-quantity-break');
        }
  
        toggleAddButton(disable = true, text, modifyClass = true) {
          const productForm = this.main_product_form;
          if (!productForm) return;
          const addButton = productForm.querySelector('[name="add"]');
          const addButtonText = productForm.querySelector('[name="add"] > span');
          if (!addButton) return;
  
          if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
          } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.deployerAdapter.addToCartText;
          }
          if (!modifyClass) return;
        }
      }
    );
  }
  
  if (!customElements.get('deployer-quantity-break-distribution')) {
    customElements.define(
      'deployer-quantity-break-distribution',
      class QuantityBreakDistributionBlock extends HTMLElement {
        constructor() {
          super();
          this.quantity_break = this.closest('deployer-quantity-breaks');
        }
  
        connectedCallback() {
          this.refresh();
  
          // Gestion des sélecteurs de quantité
          this.querySelectorAll('.quantity-break_distribution-variant-quantity-wrapper').forEach((quantity_wrapper) => {
            const quantity_add_button = quantity_wrapper.querySelector('.quantity-break_distribution-variant-add-button');
            const quantity_selector = quantity_wrapper.querySelector('.deployer-quantity');
            const quantity_input = quantity_selector.querySelector('input');
  
            quantity_add_button.addEventListener('click', (event) => {
              event.preventDefault();
              quantity_input.stepUp();
              quantity_add_button.classList.add('hidden');
              quantity_selector.classList.remove('hidden');
              this.refresh();
            });
  
            quantity_selector.querySelectorAll('button').forEach((button) => {
              button.addEventListener('click', (event) => {
                event.preventDefault();
                if (!button.disable) {
                  if (event.target.name === 'plus' && this.getNumberOfSelectedVariants() < this.quantity_break.getSelectedQuantity().dataset.quantity) quantity_input.stepUp();
                  if (event.target.name === 'minus') quantity_input.stepDown();
                  this.refresh();
                }
              });
            });
          });
        }
  
        refresh() {
          //Update the button state if not all the variants are selected
          if (this.getNumberOfSelectedVariants() < this.quantity_break.getSelectedQuantity().dataset.quantity) {
            this.quantity_break.toggleAddButton(true, '', false);
          } else {
            this.quantity_break.toggleAddButton(false, '', false);
          }
  
          //Update the quantity button add state if all variants are selected
          document.querySelectorAll('.quantity-break_distribution-variant-quantity-wrapper').forEach((quantity_wrapper) => {
            const quantity_button_add = quantity_wrapper.querySelector('.quantity-break_distribution-variant-add-button');
            if (parseInt(this.getNumberOfSelectedVariants()) === parseInt(this.quantity_break.getSelectedQuantity().dataset.quantity)) {
              quantity_button_add.disabled = true;
            } else {
              quantity_button_add.disabled = false;
            }
          });
  
          //Reset quantity selectors if too much variants are selected
          if (this.getNumberOfSelectedVariants() > this.quantity_break.getSelectedQuantity().dataset.quantity) {
            this.resetQuantitySelectors();
            this.quantity_break.toggleAddButton(true, '', false);
          }
  
          //Update the number of selected variants text
          this.setNumberOfSelectedVariantsText();
  
          //Update the form inputs
          this.updateFormInputs();
  
          //Update quantity selector buttons state based on input min and max value
          this.querySelectorAll('.quantity-break_distribution-variant-quantity-wrapper').forEach((quantity_wrapper) => {
            this.updateQuantitySelectorsState(quantity_wrapper);
          });
        }
  
        updateQuantitySelectorsState(quantity_wrapper) {
          const quantity_selector = quantity_wrapper.querySelector('.deployer-quantity');
          const quantity_input = quantity_selector.querySelector('input');
          const quantity_button_plus = quantity_selector.querySelector('button[name="plus"]');
          const quantity_button_minus = quantity_selector.querySelector('button[name="minus"]');
          const quantity_button_add = quantity_wrapper.querySelector('.quantity-break_distribution-variant-add-button');
  
          if (quantity_input.max != 0) {
            if (quantity_input.value == quantity_input.min) {
              quantity_button_plus.removeAttribute('disabled');
              quantity_button_minus.setAttribute('disabled', 'disabled');
              quantity_button_add.classList.remove('hidden');
              quantity_selector.classList.add('hidden');
            }
  
            if (quantity_input.value == quantity_input.max) {
              quantity_button_plus.setAttribute('disabled', 'disabled');
              quantity_button_minus.removeAttribute('disabled');
              quantity_button_add.classList.add('hidden');
              quantity_selector.classList.remove('hidden');
            }
  
            if (quantity_input.value > quantity_input.min && quantity_input.value < quantity_input.max) {
              quantity_button_plus.removeAttribute('disabled');
              quantity_button_minus.removeAttribute('disabled');
              quantity_button_add.classList.add('hidden');
              quantity_selector.classList.remove('hidden');
            }
          } else {
            quantity_button_add.disabled = true;
          }
        }
  
        resetQuantitySelectors() {
          this.querySelectorAll('.quantity-break_distribution-variant-quantity-wrapper').forEach((quantity_wrapper) => {
            quantity_wrapper.querySelectorAll('.deployer-quantity').forEach((quantity_selector) => {
              quantity_selector.querySelector('input').value = 0;
              quantity_selector.classList.add('hidden');
            });
            const quantity_button_add = quantity_wrapper.querySelector('.quantity-break_distribution-variant-add-button');
            quantity_button_add.classList.remove('hidden');
          });
        }
  
        getNumberOfSelectedVariants() {
          var currentNumberOfSelectedVariants = 0;
          this.querySelectorAll('.deployer-quantity').forEach((quantity_selector) => {
            const quantity_input = quantity_selector.querySelector('input');
            currentNumberOfSelectedVariants += parseInt(quantity_input.value);
          });
          return currentNumberOfSelectedVariants;
        }
  
        setNumberOfSelectedVariantsText() {
          this.querySelector('.quantity-break_distribution-header-quantity-selected').innerHTML = this.getNumberOfSelectedVariants() + '/' + this.quantity_break.getSelectedQuantity().dataset.quantity;
        }
  
        updateFormInputs() {
          this.clearFormInputs();
          // Add a quantity and variant id input to form for each selected variant
          var index = 0;
          this.querySelectorAll('.quantity-break_distribution-variant').forEach((variant) => {
            const quantity_input = variant.querySelector('.deployer-quantity input').value;
            if (quantity_input > 0) {
              index++;
              const variantInput = document.createElement('input');
              variantInput.type = 'hidden';
              variantInput.name = `items[${index}][id]`;
              variantInput.value = variant.dataset.variantId;
              this.quantity_break.main_product_form.appendChild(variantInput);
  
              const quantityInput = document.createElement('input');
              quantityInput.type = 'hidden';
              quantityInput.name = `items[${index}][quantity]`;
              quantityInput.value = quantity_input;
              this.quantity_break.main_product_form.appendChild(quantityInput);
            }
          });
        }
  
        clearFormInputs() {
          this.quantity_break.clearFormInputs();
          this.quantity_break.main_product_form.querySelectorAll('input[name="id"]').forEach((input) => {
            this.quantity_break.main_product_form.removeChild(input);
          });
        }
      }
    );
}
  
if (!customElements.get('deployer-quantity-break-variant-picker')) {
    customElements.define(
      'deployer-quantity-break-variant-picker',
      class QuantityBreakVariantPicker extends HTMLElement {
        constructor() {
          super();
          this.DeployerQuantityBreaks = this.closest('deployer-quantity-breaks');
          this.inputs = this.querySelectorAll('input[type="radio"]');
          this.selects = this.querySelectorAll('select');
          this.optionsNames = this.querySelectorAll('legend span');
          this.options = [];
          this.currentVariant = this.dataset.id;
          this.variantData = JSON.parse(this.DeployerQuantityBreaks.querySelector('[type="application/json"]').textContent);
        }
  
        connectedCallback() {
          this.updateOptions();
          this.updateVariantStatuses();
          this.inputs.forEach((input) => {
            input.addEventListener('change', (event) => {
              this.onChange(event);
            });
          });
          this.selects.forEach((select) => {
            select.addEventListener('change', (event) => {
              this.onChange(event);
            });
          });
        }
  
        onChange(event) {
          this.updateOptions();
          this.updateDataId();
          this.updateOptionsNames();
          this.updateVariantStatuses();
          this.DeployerQuantityBreaks.updateFormInputs(event.target.closest('.quantity-break'));
        }
  
        updateOptions() {
          this.options = [];
          this.options.push(
            ...Array.from(this.querySelectorAll('input[type="radio"]:checked'), (element) => {
              if (element.tagName === 'INPUT') {
                return element.value;
              }
            })
          );
          this.options.push(
            ...Array.from(this.querySelectorAll('select'), (element) => {
              if (element.tagName === 'SELECT') {
                return element.value;
              }
            })
          );
        }
  
        updateDataId() {
          this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
              .map((option, index) => {
                return this.options[index] === option;
              })
              .includes(false);
          });
          this.dataset.id = this.currentVariant.id;
          if (this.currentVariant.available === false) {
            this.dataset.available = 'false';
          } else {
            this.dataset.available = 'true';
          }
        }
  
        updateVariantStatuses() {
          const selectedOptions = this.querySelectorAll(':checked');
          const inputWrappers = [...this.querySelectorAll('fieldset')];
          let selectedOptionOneVariants = null;
          let selectedOptionTwoVariants = null;
          let selectedOptionThreeVariants = null;
          if (selectedOptions[0]) {
            selectedOptionOneVariants = this.variantData.filter((variant) => selectedOptions[0].value === variant.option1);
          }
          if (selectedOptions[1]) {
            selectedOptionTwoVariants = this.variantData.filter((variant) => selectedOptions[1].value === variant.option2);
          }
          if (selectedOptions[2]) {
            selectedOptionThreeVariants = this.variantData.filter((variant) => selectedOptions[2].value === variant.option3);
          }
          inputWrappers.forEach((option, index) => {
            if (selectedOptions.length <= 1) return;
            if (index === 0) {
              const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
              const previousOptionSelected = inputWrappers[index + 1].querySelector(':checked').value;
              const availableOptionInputsValue = selectedOptionTwoVariants.filter((variant) => variant.available && variant[`option${index + 2}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
              this.setInputAvailability(optionInputs, availableOptionInputsValue);
            } else {
              const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
              const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
              const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
              this.setInputAvailability(optionInputs, availableOptionInputsValue);
            }
          });
        }
  
        setInputAvailability(elementList, availableValuesList) {
          elementList.forEach((element) => {
            const value = element.getAttribute('value');
            const availableElement = availableValuesList.includes(value);
  
            if (element.tagName === 'INPUT') {
              if (availableElement) {
                element.classList.remove('disabled');
              } else {
                element.classList.add('disabled');
              }
            } else if (element.tagName === 'OPTION') {
              element.innerText = availableElement ? value : window.deployerAdapter.unavailableText.replace('[value]', value);
            }
          });
        }
  
        updateOptionsNames() {
          this.optionsNames.forEach((optionName, index) => {
            optionName.innerText = this.options[index];
          });
        }
  
        getVariantData() {
          this.variantData = this.variantData || JSON.parse(this.DeployerQuantityBreaks.querySelector('[type="application/json"]').textContent);
          return this.variantData;
        }
      }
    );
}
  